module.exports = __webpack_public_path__ + "static/media/plus.cac50904.svg";